import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import {
	AddDeviceGroupRequestStatus,
	AddDeviceGroupStatusEvent,
} from 'src/app/ui/add-device-group/add-device-group-main-tab.component';
import { Mode } from 'src/app/models/model';
import { NavigationHistoryService } from 'src/app/services/navigation-history.service';
import { MatDivider } from '@angular/material/list';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgPlural, NgPluralCase } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-add-device-group-confirmation',
	templateUrl: './add-device-group-confirmation.component.html',
	styleUrls: [
		'./add-device-group-confirmation.component.scss',
		'../../common/main.scss',
		'../../common/stepper.scss',
	],
	imports: [MatDivider, MatProgressSpinner, NgPlural, NgPluralCase, MatButton],
})
export class AddDeviceGroupConfirmationComponent implements OnInit {
	@Input() deviceGroupId = '';
	@Input() deviceGroupName = '';
	@Input() deviceCount = 0;
	@Input()
	addDeviceGroupRequestStatusEvents!: Observable<AddDeviceGroupStatusEvent>;

	showLoading = false;
	showSuccess = false;
	showFailure = false;

	created = true;

	constructor(
		private readonly router: Router,
		private readonly navHistory: NavigationHistoryService
	) {}

	ngOnInit(): void {
		this.addDeviceGroupRequestStatusEvents.subscribe((event) => {
			this.showLoading = false;
			this.showSuccess = false;
			this.showFailure = false;

			switch (event.status) {
				case AddDeviceGroupRequestStatus.loading:
					this.showLoading = true;
					break;
				case AddDeviceGroupRequestStatus.success:
					this.showSuccess = true;
					this.created = event?.data?.created ?? true;
					break;
				case AddDeviceGroupRequestStatus.failure:
					this.showFailure = true;
					break;
			}
		});
	}

	returnToGroups(): void {
		this.router.navigateByUrl(`/devices?tabIndex=1`);
	}

	viewGroupDetails(): void {
		this.router.navigate(['/device-group', this.deviceGroupId], {
			state: { mode: Mode.edit },
		});
	}
}
